import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import spacetime from 'spacetime';

import {CREATE_FLOWS, DOCUMENT_TYPES} from '../../../constants';
import {QUARTERS} from './CreateDocumentModal.constants';
import {styles} from './CreateDocumentModal.styles';

export const PeriodSelector = ({
  assignToFolder,
  createFlow,
  documentType,
  foldersOptions,
  isDocumentsPage,
  onReportPeriodChange,
  reportPeriod,
  selectedFolder,
  setAssignToFolder,
  years,
}) => {
  const validFlows = [
    CREATE_FLOWS.rollforward,
    CREATE_FLOWS.blankDocument,
    CREATE_FLOWS.pdf,
    CREATE_FLOWS.upload,
  ];

  if (!_.includes(validFlows, createFlow)) {
    return null;
  }

  const isPDF =
    createFlow === CREATE_FLOWS.pdf || createFlow === CREATE_FLOWS.upload;
  const isDisabled = documentType !== DOCUMENT_TYPES.quarterlyReport && !isPDF;
  const isQuarterlyRollforward =
    createFlow === CREATE_FLOWS.rollforward &&
    documentType === DOCUMENT_TYPES.quarterlyReport;

  return (
    <Stack direction="row" spacing="1rem">
      <Stack direction="row" flex={1} spacing="1rem" width="100%">
        <Stack direction="column" flex={1} spacing="0.5rem">
          <Typography style={styles.modal.label}>Report period *</Typography>
          <FormControl fullWidth>
            <Select
              disabled={isDisabled && isDocumentsPage}
              id="createDocument-reportPeriod-select"
              onChange={onReportPeriodChange}
              sx={styles.modal.select}
              value={reportPeriod}
            >
              {documentType === DOCUMENT_TYPES.quarterlyReport &&
                QUARTERS.filter((_quarter) => {
                  if (isPDF || isQuarterlyRollforward) return true;
                  // Only filter by selectedFolder year if on documents page
                  if (isDocumentsPage && selectedFolder?.year) {
                    return _quarter.split(' ')[1] === selectedFolder.year;
                  }
                  // On folders page, show all quarters for current and nearby years
                  const quarterYear = _quarter.split(' ')[1];
                  const currentYear = spacetime.now().format('year');
                  const yearDiff = Math.abs(
                    parseInt(quarterYear) - parseInt(currentYear)
                  );
                  return yearDiff <= 2; // Show quarters within 2 years of current year
                }).map((_quarter) => (
                  <MenuItem key={_quarter} value={_quarter}>
                    {_quarter}
                  </MenuItem>
                ))}
              {(documentType === DOCUMENT_TYPES.annualReport ||
                documentType === DOCUMENT_TYPES.semiAnnualReport) &&
                _.map(years, (_year) => (
                  <MenuItem key={_year.value} value={_year.value}>
                    {_year.label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Stack>
        {!isDocumentsPage && (
          <Stack direction="column" flex={1} spacing="0.5rem">
            <Typography style={styles.modal.label}>Add to folder *</Typography>
            <FormControl fullWidth>
              <Select
                MenuProps={{
                  autoFocus: false,
                  disableAutoFocus: true,
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      overflowY: 'auto',
                      scrollbarWidth: 'thin',
                    },
                  },
                  variant: 'menu',
                }}
                onChange={(e) => setAssignToFolder(e.target.value)}
                sx={styles.modal.select}
                value={assignToFolder || ''}
              >
                {foldersOptions && foldersOptions.length > 0 ? (
                  foldersOptions.map((folder) => (
                    <MenuItem key={folder.id} value={folder.id}>
                      {folder.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled key="no-folders" value="">
                    *No available folders.
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

PeriodSelector.propTypes = {
  assignToFolder: PropTypes.string,
  createFlow: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  foldersOptions: PropTypes.array,
  isDocumentsPage: PropTypes.bool.isRequired,
  onReportPeriodChange: PropTypes.func.isRequired,
  reportPeriod: PropTypes.string.isRequired,
  selectedFolder: PropTypes.object,
  setAssignToFolder: PropTypes.func.isRequired,
  years: PropTypes.array.isRequired,
};
